// ===== 画像のコピー・保存対策 =====

// 画像上の右クリックを無効化
document.addEventListener('contextmenu', function (event) {
  if (event.target.closest('img')) {
    event.preventDefault();
  }
});

// 画像のドラッグを無効化
document.addEventListener('dragstart', function (event) {
  if (event.target.closest('img')) {
    event.preventDefault();
  }
});
// ===== 商品画像ウォーターマーク =====

(function () {
    const WATERMARK_CLASS = 'penguin-image-watermark';

    function findMainProductImage() {
    const candidates = [...document.images]
        .filter(function (img) {
            // Rioの商品ギャラリー画像だけを対象にする
            return (
                img.id &&
                img.id.startsWith('pwrzswiper-img-')
            );
        })
        .map(function (img) {
            return {
                img: img,
                rect: img.getBoundingClientRect()
            };
        })
        .filter(function (item) {
            const r = item.rect;

            // 現在画面内にあり、十分な大きさの画像だけ
            return (
                r.width > 250 &&
                r.height > 250 &&
                r.left >= 0 &&
                r.top >= 0 &&
                r.left < window.innerWidth &&
                r.top < window.innerHeight
            );
        })
        .sort(function (a, b) {
            return (
                (b.rect.width * b.rect.height) -
                (a.rect.width * a.rect.height)
            );
        });

    return candidates.length ? candidates[0] : null;
}

    function createWatermark(type, text) {
        let el = document.querySelector(
            '.' + WATERMARK_CLASS + '--' + type
        );

        if (!el) {
            el = document.createElement('div');
            el.className =
                WATERMARK_CLASS + ' ' +
                WATERMARK_CLASS + '--' + type;

            el.textContent = text;
            document.body.appendChild(el);
        }

        return el;
    }

    function updateWatermarks() {
        const target = findMainProductImage();

        const name = createWatermark(
            'name',
            'ぺんぎんでりばり〜'
        );

        const service = createWatermark(
            'service',
            '韓国生地仕入れ代行'
        );

        if (!target) {
            name.style.display = 'none';
            service.style.display = 'none';
            return;
        }

        const r = target.rect;

        // 文字サイズ
        // 商品画像の幅に合わせて約14px前後
        const fontSize = Math.max(
            11,
            Math.min(17, r.width * 0.0385)
        );

        [name, service].forEach(function (el) {
            el.style.setProperty(
                'position',
                'fixed',
                'important'
            );

            el.style.setProperty(
                'display',
                'block',
                'important'
            );

            el.style.setProperty(
                'visibility',
                'visible',
                'important'
            );

            el.style.setProperty(
                'opacity',
                '1',
                'important'
            );

            el.style.setProperty(
                'z-index',
                '2147483647',
                'important'
            );

            el.style.setProperty(
                'color',
                '#ffffff',
                'important'
            );

            el.style.setProperty(
                'font-size',
                fontSize + 'px',
                'important'
            );

            el.style.setProperty(
                'font-weight',
                '700',
                'important'
            );

            el.style.setProperty(
                'line-height',
                '1',
                'important'
            );

            el.style.setProperty(
                'white-space',
                'nowrap',
                'important'
            );

            el.style.setProperty(
                'pointer-events',
                'none',
                'important'
            );

            el.style.setProperty(
                'user-select',
                'none',
                'important'
            );

            el.style.setProperty(
                'text-shadow',
                '1px 1px 3px #000, -1px -1px 3px #000',
                'important'
            );
        });

        // 左側「ぺんぎんでりばり〜」
        // 前回より少し中央寄り
        name.style.setProperty(
            'left',
            (r.left + r.width * 0.08) + 'px',
            'important'
        );

        name.style.setProperty(
            'top',
            (r.top + r.height * 0.18) + 'px',
            'important'
        );

        // 右側「韓国生地仕入れ代行」
        // 前回より少し中央寄り
        service.style.setProperty(
            'right',
            (
                window.innerWidth -
                r.right +
                r.width * 0.06
            ) + 'px',
            'important'
        );

        service.style.setProperty(
            'top',
            (
                r.bottom -
                service.offsetHeight -
                r.height * 0.18
            ) + 'px',
            'important'
        );
    }

    let ticking = false;

    function requestUpdate() {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(function () {
            updateWatermarks();
            ticking = false;
        });
    }

    function startWatermarks() {
        requestUpdate();

        // ブラウザ幅変更
        window.addEventListener(
            'resize',
            requestUpdate
        );

        // スクロール
        window.addEventListener(
            'scroll',
            requestUpdate,
            { passive: true }
        );

        // Rioの商品画像切替
        document.addEventListener(
            'click',
            function () {
                setTimeout(requestUpdate, 50);
                setTimeout(requestUpdate, 250);
                setTimeout(requestUpdate, 600);
            }
        );

        // Rioが画像を作り直した場合
        const observer = new MutationObserver(
            function () {
                requestUpdate();
            }
        );

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'src']
        });

        // Rioの遅延処理への保険
        setInterval(requestUpdate, 500);
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            startWatermarks
        );
    } else {
        startWatermarks();
    }
})();